import { createReducer, on } from '@ngrx/store';
import { BicycleState, BikeFilters } from '@shared-models';
import {
  addAdditionalGearAction,
  addNoteToCartAction,
  reserveBicycleAction,
  resetBikeFiltersAction,
  setBikeCentersAction,
  setBikeFiltersAction,
  setBikeTypesAction,
  setDriverHeightsAction,
  setFilterDateErrorAction,
  setHoursAction,
  setRentalDurationsAction,
  showFilteredResultsAction,
} from '@store-bicycle-actions';

export const initialBicycleState: BicycleState = {
  filters: {} as unknown as BikeFilters,
  showFilteredResults: false,
  filterOptions: {
    height: [],
    duration: [],
    timeFrom: [],
    type: [],
    center: [],
  },
  showDateError: false,
  bikesToBeReserved: [],
  gearId: [],
  note: '',
};

export const bicyclesReducer = createReducer(
  initialBicycleState,

  on(setBikeFiltersAction, (state, action) => ({
    ...state,
    filters: action.filters,
  })),

  on(resetBikeFiltersAction, state => ({
    ...initialBicycleState,
  })),

  on(showFilteredResultsAction, (state, action) => ({
    ...state,
    showFilteredResults: action.showResults,
  })),

  on(setRentalDurationsAction, (state, action) => ({
    ...state,
    filterOptions: { ...state.filterOptions, duration: action.durations },
  })),

  on(setDriverHeightsAction, (state, action) => ({
    ...state,
    filterOptions: { ...state.filterOptions, height: action.heights },
  })),

  on(setHoursAction, (state, action) => ({
    ...state,
    filterOptions: { ...state.filterOptions, timeFrom: action.hours },
  })),

  on(setBikeTypesAction, (state, action) => ({
    ...state,
    filterOptions: { ...state.filterOptions, type: action.bikeTypes },
  })),

  on(setBikeCentersAction, (state, action) => ({
    ...state,
    filterOptions: { ...state.filterOptions, center: action.bikeCenters },
  })),

  on(setFilterDateErrorAction, (state, action) => ({
    ...state,
    showDateError: action.showError,
  })),

  on(reserveBicycleAction, (state, action) => {
    const data = [...state.bikesToBeReserved];
    data[action.index] = action.bicycle;

    return {
      ...state,
      bikesToBeReserved: data,
    };
  }),

  on(addAdditionalGearAction, (state, action) => {
    if (action.control === 'reset') {
      return { ...state, gearId: [] };
    } else if (action.control === 'add') {
      return { ...state, gearId: [...state.gearId, action.gearId] };
    } else if (action.control === 'remove') {
      const index = state.gearId.indexOf(action.gearId);
      const newIds = [...state.gearId];
      newIds.splice(index, 1);
      return {
        ...state,
        gearId: [...newIds],
      };
    }
    return { ...state };
  }),

  on(addNoteToCartAction, (state, action) => ({
    ...state,
    note: action.note,
  })),
);
